import store from "@/store";

export default [
    {
        path: '/partners',
        name: 'partners',
        meta: {
            layout: 'emptyLayout',
            requiresAuth: true,
            title: 'Точки продажу',
            breadcrumb: 'Точки продажу',
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.IS_PARTNER_STATUS) {
                console.log(to.query.onlyTrashed, 'test')
                if (to.query.onlyTrashed === 'true') {
                    to.meta.breadcrumb = 'Видалені точки продажу'
                } else {
                    to.meta.breadcrumb = 'Точки продажу'
                }
                next();
            } else {
                next({name: 'prime'})
            }
        },
        // component: () => import('../views/partners/Index.vue'),
        component: () => import('../pages/partners-page'),
        // props: route => ({
        //     onlyTrashed: route.query.onlyTrashed === 'true' || route.query.onlyTrashed === '1'
        // })
    },
    {
        path: '/partners/create',
        name: 'create-partner',
        meta: {
            layout: 'emptyLayout',
            requiresAuth: true,
            title: 'Створити точку продажу',
            breadcrumb: 'Створити точку продажу',
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.IS_PARTNER_STATUS) {
                next();
            } else {
                next({name: 'prime'})
            }
        },
        component: () => import('../pages/partners-page/CreateEdit.vue')
    },
    {
        path: '/partners/:id',
        name: 'edit-partner',
        meta: {
            layout: 'emptyLayout',
            requiresAuth: true,
            title: 'Редагувати точку продажу',
            breadcrumb: 'Редагувати точку продажу',
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.IS_PARTNER_STATUS) {
                next();
            } else {
                next({name: 'prime'})
            }
        },
        component: () => import('../pages/partners-page/CreateEdit.vue')
    },
    {
        path: '/partners/:id/tariff-settings',
        name: 'partner-tariff-settings',
        meta: {
            layout: 'emptyLayout',
            requiresAuth: true,
            // title: 'Тарифи точки продажу id:',
            // breadcrumb: 'Тарифи точки продажу id:',
        },
        beforeEnter: (to, from, next) => {
            to.meta.title = `Тарифи точки продажу id: ${to.params.id}`
            to.meta.breadcrumb = `Тарифи точки продажу id: ${to.params.id}`
            if (!store.getters.IS_PARTNER_STATUS) {
                next();
            } else {
                next({name: 'prime'})
            }
        },
        component: () => import('../pages/products-page')
    },
    {
        path: '/partners/:id/promo-codes',
        name: 'partner-promo-codes',
        meta: {
            layout: 'emptyLayout',
            requiresAuth: true,
        },
        beforeEnter: (to, from, next) => {
            to.meta.title = `Промокоди точки продажу id: ${to.params.id}`
            to.meta.breadcrumb = `Промокоди точки продажу id: ${to.params.id}`
            if (!store.getters.IS_PARTNER_STATUS) {
                next();
            } else {
                next({name: 'prime'})
            }
        },
        component: () => import('../pages/partners-page/PromoCodes.vue')
    },
]
